// src/apiServices/vendorAssembliesApi.ts
import api from "../api";

export type AssemblyBriefDto = {
  finalAssemblyId: number;
  masterAssemblyId?: number | null;
  componentPartNumber?: string | null;
  componentDescription?: string | null;
  currentVersionId?: number | string | null;
  approvedOn?: string | null;
  isVisible?: boolean | null;
};

export type VendorAssemblyMapDto = {
  vendorId: number;
  vendorName?: string | null;
  assigned: AssemblyBriefDto[];
  available: AssemblyBriefDto[];
};

type ApiResponse<T = any> = { statusCode: number; message?: string; data?: T };

export async function fetchVendorMap(oem: string, vendorId: number): Promise<VendorAssemblyMapDto> {
  const { data } = await api.get<ApiResponse<VendorAssemblyMapDto>>(`/VendorAssemblies/map/${oem}/${vendorId}`);
  if (data?.statusCode === 200 && data.data) {
    const raw: any = data.data;
    const assigned = Array.isArray(raw?.assigned)
      ? raw.assigned.map((row: any) => ({
          finalAssemblyId: Number(row?.finalAssemblyId ?? row?.FinalAssemblyId ?? 0),
          masterAssemblyId: row?.masterAssemblyId ?? row?.MasterAssemblyId ?? null,
          currentVersionId: row?.currentVersionId ?? row?.CurrentVersionId ?? null,
          componentPartNumber: row?.componentPartNumber ?? row?.ComponentPartNumber ?? null,
          componentDescription: row?.componentDescription ?? row?.ComponentDescription ?? null,
          approvedOn: row?.approvedOn ?? row?.ApprovedOn ?? null,
          isVisible: row?.isVisible ?? row?.IsVisible ?? null,
        }))
      : [];
    const available = Array.isArray(raw?.available)
      ? raw.available.map((row: any) => ({
          finalAssemblyId: Number(row?.finalAssemblyId ?? row?.FinalAssemblyId ?? 0),
          masterAssemblyId: row?.masterAssemblyId ?? row?.MasterAssemblyId ?? null,
          currentVersionId: row?.currentVersionId ?? row?.CurrentVersionId ?? null,
          componentPartNumber: row?.componentPartNumber ?? row?.ComponentPartNumber ?? null,
          componentDescription: row?.componentDescription ?? row?.ComponentDescription ?? null,
          approvedOn: row?.approvedOn ?? row?.ApprovedOn ?? null,
          isVisible: row?.isVisible ?? row?.IsVisible ?? null,
        }))
      : [];
    return {
      vendorId: Number(raw?.vendorId ?? raw?.VendorId ?? vendorId),
      vendorName: raw?.vendorName ?? raw?.VendorName ?? "",
      assigned,
      available,
    };
  }
  return { vendorId, vendorName: "", assigned: [], available: [] };
}

export async function assignAssemblyToVendor(oem: string, vendorId: number, finalAssemblyId: number) {
  const { data } = await api.post<ApiResponse>(`/VendorAssemblies/${oem}/${vendorId}/${finalAssemblyId}`);
  return data;
}

export async function deactivateAssemblyForVendor(oem: string, vendorId: number, finalAssemblyId: number) {
  const { data } = await api.delete<ApiResponse>(`/VendorAssemblies/${oem}/${vendorId}/${finalAssemblyId}`);
  return data;
}
